import './vendor';
import lazyLoading from './modules/lazyLoading';
require('../../node_modules/@cmyee/pushy/js/pushy.js')
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')
import videojs from 'video.js';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import Swiper, { Pagination, Autoplay, Navigation, EffectFade, Controller, Mousewheel, Scrollbar} from 'swiper';
Swiper.use([Autoplay, Navigation, EffectFade,  Pagination, Controller, Mousewheel, Scrollbar ]);


const sliderContent = new Swiper('.content-slider', { 
	loop: false,
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 30,
	speed: 1000,
	rewind: true,
	navigation: {
		prevEl: '#slider-content-prev',
		nextEl: '#slider-content-next',
	},
	scrollbar: {
		el: '.swiper-scrollbar',
		draggable: true
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'fraction',
	},
        breakpoints: {
            1920: {
                slidesPerView: 2,
            },
            1028: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 2,
            },
	    320: {
                slidesPerView: 1,
            }
        }
});

lazyLoading.init();

document.addEventListener('DOMContentLoaded', () => {
	FetchIt.Message = {
	  success(message) {
	    Swal.fire({
	      icon: 'success',
	      title: message,
	      showConfirmButton: false,
	    });
	  },
	  error(message) {
	//     Swal.fire({
	//       icon: 'error',
	//       title: message,
	//       showConfirmButton: false,
	//     });
	  },
	}
});

if(document.querySelector(".field__file")) {
	let fields = document.querySelectorAll('.field__file');
	Array.prototype.forEach.call(fields, function (input) {
	let label = input.nextElementSibling,
		labelVal = label.querySelector('.field__file-fake').innerText;
	
	input.addEventListener('change', function (e) {
		let countFiles = '';
		if (this.files && this.files.length >= 1)
		countFiles = this.files.length;
	
		if (countFiles)
		// label.querySelector('.field__file-fake').innerText = 'Выбрано файлов: ' + countFiles;
		label.querySelector('.field__file-fake').innerText = 'Файл добавлен ';
		else
		label.querySelector('.field__file-fake').innerText = labelVal;
	});
	});
}




/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade',
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});

//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$("").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "assets/build/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$(".done-w").fadeIn();
		setTimeout(function() {
			// Done Functions
			$(".done-w").fadeOut();
			$.magnificPopup.close();
			th.trigger("reset");
		}, 3000);
	});
	return false;
});

$(".accordeon dd").hide().prev().click(function() {
	$(this).parents(".accordeon").find("dd").not(this).slideUp().prev().removeClass("active");
	$(this).next().not(":visible").slideDown().prev().addClass("active");
});



$(".gallery__item ").not(":first").hide();
$(".gallery__tab").click(function() {
	$(".gallery__tab").removeClass("active").eq($(this).index()).addClass("active");
	$(".gallery__item").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("active");

/*Magnific галерея*/
$('.popup-gallery').magnificPopup({
	delegate: 'a',
	type: 'image',
	tLoading: 'Загрузка изображения #%curr%...',
	mainClass: 'mfp-fade mfp-img-mobile',
	gallery: {
		enabled: true,
		navigateByImgClick: true,
		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	},
	image: {
		tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
		titleSrc: function(item) {
			return '';
		}
	}
});


if(document.querySelector("#video-js")) {
	let video = videojs('#video-js', {
		controls: false,
		autoplay: true,
		loop: true,
		height: '100%',
		poster: '/video/cover.jpg',
			html5: {
			nativeAudioTracks: false,
			nativeVideoTracks: false,
			nativeTextTracks: false,
			hls: {
			overrideNative: true,
			},
		},
	});

	video.src({
		type: 'application/x-mpegURL',
		src: '/assets/build/video/adaoil.m3u8',
		withCredentials: true,
	});


	let srcvideo =  $('#video-js').find('source').attr('src')

}
window.videojs = videojs;

	let btnModal = document.querySelectorAll('.btn--modal');
	btnModal.forEach(element => element.addEventListener('click', replaceTitleModal));

	function replaceTitleModal() {
		let modalForm = document.querySelector('#vacancy');
		let title = modalForm.querySelector('.modalform__title span');
		let theme = modalForm.querySelector('.form__theme');
		title.innerHTML = this.dataset.title;
		theme.value = this.dataset.title;

		console.log(this.dataset.title)
	}
